import Blocked from '@/assets/svg/icons/Blocked.svg'
import BlueLock from '@/assets/svg/icons/BlueLock.svg'
import GreenCheck from '@/assets/svg/icons/GreenCheck.svg'
import GreenEllipsis from '@/assets/svg/icons/GreenEllipsis.svg'
import RedCrossCircle from '@/assets/svg/icons/RedCrossCircle.svg'
import RedForbiddenCircle from '@/assets/svg/icons/RedForbiddenCircle.svg'
import RedMinusCircle from '@/assets/svg/icons/RedMinusCircle.svg'
import RedRemoved from '@/assets/svg/icons/RedRemoved.svg'
import OutOfOrder from '@/assets/svg/icons/RedOutOfOrder.svg'
import SlateQuestionCircle from '@/assets/svg/icons/SlateQuestionCircle.svg'
import StoneCrossCircle from '@/assets/svg/icons/StoneCrossCircle.svg'
import YellowBolt from '@/assets/svg/icons/YellowBolt.svg'
import YellowCar from '@/assets/svg/icons/YellowCar.svg'
import YellowEllipsis from '@/assets/svg/icons/YellowEllipsis.svg'
import YellowExpand from '@/assets/svg/icons/YellowExpand.svg'
import YellowHourglass from '@/assets/svg/icons/YellowHourglass.svg'
import YellowPause from '@/assets/svg/icons/YellowPause.svg'
import YellowPauseCircle from '@/assets/svg/icons/YellowPauseCircle.svg'

type IconStyle =
  | 'blueLock'
  | 'yellowBolt'
  | 'greenCheck'
  | 'greenEllipsis'
  | 'redCrossCircle'
  | 'redForbiddenCircle'
  | 'redMinusCircle'
  | 'redRemoved'
  | 'slateQuestionCircle'
  | 'stoneCrossCircle'
  | 'yellowCar'
  | 'yellowExpand'
  | 'yellowHourglass'
  | 'yellowPause'
  | 'yellowPauseCircle'
  | 'yellowEllipsis'
  | 'redBlocked'
  | 'redOutOfOrder'

export function getIcon(style: IconStyle) {
  const iconMap: Record<IconStyle, string> = {
    blueLock: BlueLock,
    greenCheck: GreenCheck,
    greenEllipsis: GreenEllipsis,
    yellowBolt: YellowBolt,
    redCrossCircle: RedCrossCircle,
    redMinusCircle: RedMinusCircle,
    redForbiddenCircle: RedForbiddenCircle,
    stoneCrossCircle: StoneCrossCircle,
    slateQuestionCircle: SlateQuestionCircle,
    yellowCar: YellowCar,
    yellowExpand: YellowExpand,
    yellowHourglass: YellowHourglass,
    yellowPause: YellowPause,
    yellowPauseCircle: YellowPauseCircle,
    yellowEllipsis: YellowEllipsis,
    redBlocked: Blocked,
    redOutOfOrder: OutOfOrder,
    redRemoved: RedRemoved
  }
  return iconMap[style]
}

export function getBooleanIcon(value: boolean) {
  return value ? GreenCheck : RedCrossCircle
}
